export default {
    "name": "电小丫",
    "ossUrl": 'https://dianxy-test.oss-cn-hangzhou.aliyuncs.com/',
    "map":{
        "latitude":  118.058059,
        "longitude":24.614246,
        "city": "杭州",
        "store": "电小丫总部"
    },
    "showWithdrawal":false, //显示金主提现手续费
    "hideGuide":true, // 隐藏租借引导页
    "hideOuterChain":true,// 隐藏外链聚合页配置
    "hideOrderConfig":true// 隐藏订单配置
}



// WEBPACK FOOTER //
// ./src/Config.js